import mixpanel, { Mixpanel } from "mixpanel-browser";

export class MixpanelAnalyticsPlatform implements IAnalyticsPlatform {
  constructor(id: string) {
    this.initialise(id);
  }

  mixpanelInstance: Mixpanel | null = null;

  initialise(id: string): void {
    try {
      this.mixpanelInstance = mixpanel.init(
        id,
        {
          debug: false,
          track_pageview: true,
          persistence: "localStorage",
        },
        id
      );
    } catch (e) {
      console.error("Loading Mixpanel can fail due to Ad-blockers", e);
    }
  }

  setIdentity(identity: string): void {
    this.mixpanelInstance?.identify(identity);
  }

  trackEvent(event: string, properties?: Record<string, any>): void {
    this.mixpanelInstance?.track(event, properties);
  }

  logout(): void {
    this.mixpanelInstance?.reset();
  }
}
